import { DataAset, DataBerkas, DataKeluarga, SysBerkas } from "@/types";
import { create } from "zustand";

export type Item = {
  label: string;
  value: string | number | null | undefined;
  isValidated: boolean;
};

type ExtendedDataKeluarga = DataKeluarga & {
  isValidated?: boolean;
};

type DataKeluargaTambahan = {
  id_data_pendaftaran: string;
  biaya_hidup_keluarga_perbulan: number;
  jumlah_tanggungan_orangtua_wali: string;
  jumlah_tanggungan_orangtua_wali_text?: string;
  isValidated?: boolean;
} | null;

type ExtendedDataAset = DataAset & {
  isValidated?: boolean;
};

type ExtendedSysBerkas = SysBerkas & {
  isValidated?: boolean;
};

export type ExtendedDataBerkas = {
  listSysBerkas: ExtendedSysBerkas[];
  listDataBerkasSiswa: DataBerkas[];
} | null;

type ValidasiState = {
  dataBiodata: Item[];
  dataListKeluarga: ExtendedDataKeluarga[];
  dataKeluargaTambahan: DataKeluargaTambahan;
  dataListAset: ExtendedDataAset[];
  dataListBerkas: ExtendedDataBerkas;
  setDataBiodata: (updatedData: Item[]) => void;
  setDataListKeluarga: (updatedData: ExtendedDataKeluarga[]) => void;
  setDataKeluargaTambahan: (updatedData: DataKeluargaTambahan) => void;
  setDataListAset: (updatedData: ExtendedDataAset[]) => void;
  setDataListBerkas: (updatedData: ExtendedDataBerkas) => void;
};

export const useDataValidasi = create<ValidasiState>((set) => ({
  dataBiodata: [],
  dataListKeluarga: [],
  dataKeluargaTambahan: null,
  dataListAset: [],
  dataListBerkas: null,
  setDataBiodata: (updatedData: Item[]) => set({ dataBiodata: updatedData }),
  setDataListKeluarga: (updatedData: ExtendedDataKeluarga[]) =>
    set({ dataListKeluarga: updatedData }),
  setDataKeluargaTambahan: (updatedData: DataKeluargaTambahan) =>
    set({ dataKeluargaTambahan: updatedData }),
  setDataListAset: (updatedData: ExtendedDataAset[]) =>
    set({ dataListAset: updatedData }),
  setDataListBerkas: (updatedData: ExtendedDataBerkas) =>
    set({ dataListBerkas: updatedData }),
}));
